import { Injectable } from '@angular/core';
import { Router, 
// RouterStateSnapshot,
UrlSegment } from '@angular/router';
// import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { UserActiveService } from './user-active.service';
import { Route } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
	constructor(
		private router: Router,
		// private activatedRoute: ActivatedRoute,
		private authService: UserActiveService
	) {}

	canLoad(route: Route, segments: UrlSegment[]): boolean | Observable<boolean> {
		const currentUser = this.authService.currentUserValue;
		if (segments.join('/').includes('public/')) {
			const access = this.authService.authPublic(
				Number(segments[segments.length - 1])
			);
			return access;
		} else if (currentUser && currentUser.Name !== '') {
			return true;
		}

		// not logged in so redirect to login page with the return url
		this.router.navigate(['/outside/login'], {
			queryParams: {
				returnUrl: segments.length > 1 ? segments.join('/') : 'inside'
			}
		});
		return false;
	}
}
